import { gql } from '@apollo/client'

import { PROMOTION_APPLICATION_FIELDS } from './promotion'

export const BOOKING_DETAILS_QUERY = gql`
  query BookingDetail($reservationNumber: String!) {
    bookingDetail(reservationNumber: $reservationNumber) {
      basicDetails {
        id
        reservationNumber
        accommodationName
        accommodationNameTranslatedList {
          nativeLabel
          label
          value
        }
        createdAt
        expiredAt
        crsStatus
        pmsStatus
        reservationType
        currency
        numberOfRooms
        numberOfGuest
        propertyTelephone
        propertyWebsite
        propertyAddress
        propertyAddressFA
        propertyCode
        tenantCode
      }
      bookerInfo {
        firstName
        lastName
        fullName
        idNumber
        email
        telephone
        isForeigner
      }
      canCancel
      canModify
      canConfirm
      lastChanger {
        name
        email
        ip
      }
      sourceInfo {
        name
        code: displayChannelCode
        reservationNumber
        shortName
        paymentNumber
      }
      rooms {
        crsStatus
        pmsStatus
        canCancel
        canModify
        reservationNumber
        pmsNumber
        pmsSecondaryNumber
        channelName
        channelID
        numberOfAdults
        addBed
        occupancy {
          adults
          extraBeds
        }
        cancellationPolicy {
          name
          description
          descriptionTranslatedList {
            label
            nativeLabel
            value
          }
          policies {
            applied
            priority
            penaltyAmount
            deadline
            deadlineTimeOffset
            penaltyType
            policyType
          }
        }
        modificationPolicy {
          name
          description
          descriptionTranslatedList {
            label
            nativeLabel
            value
          }
          policies {
            applied
            priority
            penaltyAmount
            deadline
            deadlineTimeOffset
            penaltyType
            policyType
          }
        }
        ratePolicy
        ratePolicyTranslatedList {
          label
          nativeLabel
          value
        }
        checkIn
        checkOut
        payablePrice
        providerName
        originalPrice
        discount
        additionalDiscount
        cancelationPenalty
        changePenalty
        extraBedPrice
        boardType
        profiles {
          fullName
          firstName
          lastName
          isForeigner
          email
          mobile
          phone
          identificationNo
        }
        roomTypeName
        roomTypeCode
        failedReason
        ratePlanName
        ratePlanCode
        ratesPerDay {
          date
          roomRate
          extraBedRate
        }
      }
      description
      roomsPriceDetails {
        roomTypeCode
        roomTypeName
        ratePlanCode
        chargePerDays {
          date
          charge {
            itemName
            quantity
            discount
            rate
            total
            remark
          }
        }
        chargePerRoomStay {
          itemName
          quantity
          discount
          rate
          total
          remark
        }
        totalChargePerRoomStay
        totalChargePerDay
      }
      billingSummary {
        roomsPrice {
          quantity
          price
          roomTypeName
          ratePlanCode
        }
        subTotalBeforeDiscount
        subTotalAfterDiscount
        discount
        additionalDiscount
        taxAndFees
        amendmentPenaltyAmount
        cancelationPenaltyAmount
        refundAmount
        reservationMethod
        curruncy
        finalAmount
      }
      promotionApplication {
        __typename
        ...PromotionApplicationFields
      }
    }
  }
  ${PROMOTION_APPLICATION_FIELDS}
`

export const BOOKING_DETAILS_VOUCHER_QUERY = gql`
  query BookingDetailVoucher($hash: String!) {
    bookingDetailVoucher(hash: $hash) {
      basicDetails {
        id
        reservationNumber
        displayReservationNumber
        accommodationName
        accommodationNameTranslatedList {
          nativeLabel
          label
          value
        }
        createdAt
        expiredAt
        crsStatus
        pmsStatus
        reservationType
        currency
        numberOfRooms
        numberOfGuest
        propertyTelephone
        propertyWebsite
        propertyAddress
        propertyAddressFA
        propertyCode
        tenantCode
      }
      bookerInfo {
        firstName
        lastName
        fullName
        idNumber
        email
        telephone
        isForeigner
      }
      canCancel
      canModify
      canConfirm
      lastChanger {
        name
        email
        ip
      }
      sourceInfo {
        name
        code: displayChannelCode
        reservationNumber
        shortName
        paymentNumber
      }
      rooms {
        crsStatus
        pmsStatus
        canCancel
        canModify
        reservationNumber
        displayReservationNumber
        pmsNumber
        pmsSecondaryNumber
        channelName
        channelID
        numberOfAdults
        addBed
        occupancy {
          adults
          extraBeds
        }
        cancellationPolicy {
          name
          description
          descriptionTranslatedList {
            label
            nativeLabel
            value
          }
          policies {
            applied
            priority
            penaltyAmount
            deadline
            deadlineTimeOffset
            penaltyType
            policyType
          }
        }
        modificationPolicy {
          name
          description
          descriptionTranslatedList {
            label
            nativeLabel
            value
          }
          policies {
            applied
            priority
            penaltyAmount
            deadline
            deadlineTimeOffset
            penaltyType
            policyType
          }
        }
        ratePolicy
        ratePolicyTranslatedList {
          label
          nativeLabel
          value
        }
        checkIn
        checkOut
        payablePrice
        providerName
        originalPrice
        discount
        additionalDiscount
        promotionDiscount
        cancelationPenalty
        changePenalty
        extraBedPrice
        boardType
        profiles {
          fullName
          firstName
          lastName
          isForeigner
          email
          mobile
          phone
          identificationNo
        }
        roomTypeName
        roomTypeCode
        failedReason
        ratePlanName
        ratePlanCode
        ratesPerDay {
          date
          roomRate
          extraBedRate
        }
      }
      description
      roomsPriceDetails {
        roomTypeCode
        roomTypeName
        ratePlanCode
        chargePerDays {
          date
          charge {
            itemName
            quantity
            discount
            rate
            total
            remark
          }
        }
        chargePerRoomStay {
          itemName
          quantity
          discount
          rate
          total
          remark
        }
        totalChargePerRoomStay
        totalChargePerDay
      }
      billingSummary {
        roomsPrice {
          quantity
          price
          roomTypeName
          ratePlanCode
        }
        subTotalBeforeDiscount
        subTotalAfterDiscount
        discount
        additionalDiscount
        taxAndFees
        amendmentPenaltyAmount
        cancelationPenaltyAmount
        refundAmount
        reservationMethod
        curruncy
        finalAmount
      }
      promotionApplication {
        __typename
        ...PromotionApplicationFields
      }
    }
  }
  ${PROMOTION_APPLICATION_FIELDS}
`
